import { create } from 'zustand';

export const useHeaderSettingsStore = create((set) => ({
  openSettings: false,
  setOpenSettings: (openSettings) => set({ openSettings }),
  showDeal: true,
  setShowDeal: (showDeal) => set({ showDeal }),
  openDialogHelp: false,
  setOpenDialogHelp: (openDialogHelp) => set({ openDialogHelp }),
  showTeamsModal: false,
  setShowTeamsModal: (showTeamsModal) => set({ showTeamsModal }),
  openDialogShort: false,
  setOpenDialogShort: (openDialogShort) => set({ openDialogShort }),
  openDialogDiscord: false,
  setOpenDialogDiscord: (openDialogDiscord) => set({ openDialogDiscord }),
}));
